module.exports = __webpack_public_path__ + "img/order5.c05d2285.png";